import { Loading } from '@lib/components'
import type React from 'react'

import { clsJoin } from '@/utils'
import { ExportBadge } from '../ExportBadge'
import css from './styles.module.css'

type IconProps = {
  className: string
}

interface Props extends React.PropsWithChildren {
  label: string
  exportable: boolean
  loading?: boolean
  icon: React.FC<IconProps>
  isNew?: boolean
  onClick: () => void
}

export const ExportItem: React.FC<Props> = ({
  label,
  exportable,
  loading = false,
  icon: Icon,
  isNew = false,
  children,
  onClick,
}) => {
  const cn = clsJoin(
    css.item,
    !exportable && css.disabled,
    loading && css.loading
  )

  return (
    <div onClick={onClick} className={cn}>
      {children}

      <div className={css.icon_wrap}>
        {loading ? (
          <div className={css.loading_wrap}>
            <Loading color="gray" type="smallx2" />
          </div>
        ) : (
          <Icon className={css.icon} />
        )}
      </div>

      <div className={css.label}>{label}</div>

      <ExportBadge isNew={isNew} exportable={exportable} />
    </div>
  )
}
